import { useAuthStore } from '@/stores/authStore'
import { USER_ROLE } from '@/utils/constants'

/**
 * 角色辅助 Hook
 */
export function useRole() {
  const user = useAuthStore((state) => state.user)
  const role = user?.role ?? 0
  return {
    role,
    isUser: role >= USER_ROLE.COMMON,
    isAdmin: role >= USER_ROLE.ADMIN,
    isRoot: role >= USER_ROLE.ROOT,
  }
}
